import React from 'react';
import { _ProductDetail } from './Products';
import ProductDetailTable from './ProductDetailTable';
import FazonetkaDescription from './FazonetkaDescription';

interface Props {
  pDetailData: _ProductDetail;
}

/**
 * Dle návrhu grafika se popis a tabulka velikostí NEzobrazují v tabech, ale jako
 * dvě samostatné sekce pod sebou ("Popis produktu", "Materiál a potřebné množství").
 * Recenze a Dotazy zatím zůstávají skryté (stejně jako dřív byly visible:false).
 */
const ProductDetailTabs: React.FC<Props> = ({ pDetailData }) => {
  const hasDescription = !!(pDetailData.description && pDetailData.description.trim().length > 0);
  const hasSizes = !!(pDetailData.size_table && pDetailData.size_table.trim().length > 0);

  if (!hasDescription && !hasSizes) return null;

  return (
    <div className="pd-sections">
      {hasDescription && (
        <section className="pd-section">
          <h2 className="pd-section__title">Popis produktu</h2>
          <FazonetkaDescription html={pDetailData.description} />
        </section>
      )}

      {hasSizes && (
        <section className="pd-section">
          <h2 className="pd-section__title">Materiál a potřebné množství</h2>
          <div className="pd-section__body">
            <ProductDetailTable pDetailData={pDetailData} />
          </div>
        </section>
      )}
    </div>
  );
};

export default ProductDetailTabs;
